import React from "react";

const SalesNormalization = ({ row }) => {
  return <div>{row?.salesTickets?.toLocaleString()}</div>;
};

export default SalesNormalization;
